<template>
  <PageTemplate>
    <form
      @submit.prevent="saveChanges"
      @change="handleChange"
      @invalid.capture.prevent="handleInvalid"
    >
      <div class="row">
        <div class="col-lg-6">
          <h1>Edit Profile</h1>
        </div>
        <div class="col-lg-6">
          <v-button-group is-right>
            <v-button
              size="lg"
              color="secondary"
              has-min-width
              @click="$router.push('/change-password')"
            >
              Change Password
            </v-button>
            <v-button
              size="lg"
              :is-disabled="!canSave"
              has-min-width
              is-submit
            >
              Save Changes
            </v-button>
          </v-button-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <v-card title="Details">
            <v-fieldset
              id="first_name"
              v-model="info.first_name"
              name="first_name"
              text="First Name*"
              type="text"
              is-required
              :help-text="fieldErrors.first_name"
            />
            <v-fieldset
              id="last_name"
              v-model="info.last_name"
              name="last_name"
              text="Last Name*"
              type="text"
              is-required
              :help-text="fieldErrors.last_name"
            />
            <v-fieldset
              id="email"
              v-model="info.email"
              name="email"
              text="Email Address*"
              type="email"
              is-required
              :help-text="fieldErrors.email"
            />
            <v-fieldset
              id="mobile_number"
              v-model="info.mobile_number"
              name="mobile_number"
              text="Phone*"
              type="text"
              is-required
              :help-text="fieldErrors.mobile_number"
            />
          </v-card>
        </div>
        <div class="col-lg-6">
          <v-card title="Address Details">
            <div class="row">
              <v-fieldset
                id="address"
                v-model="info.address"
                name="address"
                class="col-12"
                text="Address*"
                type="text"
                is-required
                :help-text="fieldErrors.address"
              />
              <v-fieldset
                id="country"
                v-model="info.country"
                name="country"
                class="col-lg-6"
                text="Country"
                type="text"
              />
              <v-fieldset
                v-if="states.length > 0"
                id="state"
                v-model="info.state"
                name="state"
                class="col-lg-6"
                text="State"
                :select-options="states"
                :disabled="stateDisabled"
              />
              <v-fieldset
                id="suburb"
                v-model="info.suburb"
                name="suburb"
                class="col-lg-6"
                text="Suburb"
                type="text"
              />
              <v-fieldset
                id="postcode"
                v-model="info.postcode"
                name="postcode"
                class="col-lg-6"
                text="Post Code"
                type="text"
              />
            </div>
          </v-card>
        </div>
      </div>
      <v-button
        color="transparent"
        @click="performCancel()"
      >
        Cancel
      </v-button>
    </form>
    <v-spinner
      v-if="isLoading"
      is-full
    />
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Button from "@/atoms/Button";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import Card from "@/molecules/Card";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb} from "../common/tableFunctions";
  import Spinner from "@/atoms/Spinner";
  import {GET_USER, UPDATE_PROFILE} from "@/store/actions.type";
  import constants from "@/common/constants";
  import routes from "@/common/routes";

  export default {
    name: "EditProfile",
    components: {
      'v-button': Button,
      'v-button-group': ButtonGroup,
      'v-fieldset': Fieldset,
      'v-card': Card,
      "v-spinner": Spinner,
      PageTemplate
    },
    data: () => ({
      states: constants.USER_STATES,
      canSave: false,
      stateDisabled: false,
      emailError: null,
      isLoading: false,
      fieldErrors: {},
      info: {country:''}
    }),
    computed: {
      // info: {
      //   get: function () {
      //     return this.$store.getters.getUser;
      //   },
      //   set: function (newValue) {
      //     this.info = newValue;
      //   }
      // }
    },
    watch: {
      'info.country': {
        handler: function (val, oldVal) {
          // if country != 'au', force to set 'OTHER'
          if (val && val.toString().toLowerCase() !== 'australia') {
            this.info.state = 'Other';
            this.stateDisabled =  true;
          } else {
            this.resetStates();
            this.stateDisabled =  false;
          }
        }
      }
    },
    mounted() {
      this.info = JSON.parse(JSON.stringify(this.$store.getters.getUser));
      this.updateBreadCrumb();
      this.info.id = this.$store.getters.getUser.id;
      this.info.resource_id = this.$store.getters.getUser.resource_id;
    },
    methods: {
      resetStates() {
        this.states = constants.USER_STATES;
      },
      performCancel() {
        this.$router.push('/profile');
      },
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Profile'] = routes.PROFILE;
        breadcrumbs['Edit Profile'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      saveChanges: function () {
        let params = this.cleanObj(this.info);
        if(!params) {
          this.canSave =  false;
          return;
        }
        this.isLoading = true;
        this.$store.dispatch(UPDATE_PROFILE, {params})
          .then(response => {
            this.isLoading = false;
            this.$notify({
              title: 'Success',
              text: 'Your profile request has been submitted to NATA for approval!',
              type: 'success'
            });
            //  refresh state and redirect to profile page
            this.$router.push(routes.PROFILE);
          })
          .catch(error => {
            this.isLoading = false;
            for (const [key, value] of Object.entries(error.data.data)) {
              this.$notify({
                title: 'Error',
                text: value[0],
                type: 'error'
              });
            }
          })
      },
      handleChange(evt) {
        this.canSave = true;
        this.fieldErrors = {
          ...this.fieldErrors,
          [evt.target.name]: ""
        };
      },
      handleInvalid(evt) {
        this.fieldErrors = {
          ...this.fieldErrors,
          [evt.target.name]: evt.target.validationMessage
        };
      },
      cleanObj: function (obj) {
        let res = {};
        delete obj['committeeAdmin'];
        delete obj['roles'];
        delete obj['committees'];
        for (var propName in obj) {
          if(obj[propName] !== this.$store.getters.getUser[propName])
            res[propName] = obj[propName];
        }
        if(Object.keys(res).length > 0) {
          res.id = this.$store.getters.getUser.id;
          res.resource_id = this.$store.getters.getUser.resource_id;
        }else {
          return false;
        }
        return res;
      }
    }
  }
</script>

